import { Component, OnInit } from '@angular/core';
import { CertificateService } from '../services/certificate.service';
import { saveAs } from 'file-saver';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LogService } from '../services/log.service';
@Component({
  selector: 'app-student-certificate',
  templateUrl: './student-certificate.component.html',
  styleUrls: ['./student-certificate.component.css']
})
export class StudentCertificateComponent implements OnInit {

  public student_certificates: any[] = [];

  constructor (public certificateService: CertificateService, public log: LogService, private snackbar?: MatSnackBar,) { }

  ngOnInit (): void {
    this.fetchCertificates();
    // this.log
    //   .addLog({
    //   action: "Access",
    //   component: "Student Certificate",
    //   details: `Accessed Student Certificate`
    // }).subscribe(data => { });
  }

  fetchCertificates (): void {
    this.certificateService.fetchStudentCertificate().subscribe(
      (response: any) => {
        if (response.success) {
          this.student_certificates = JSON.parse(JSON.stringify(response.data));

          console.log(this.student_certificates);
          this.log
            .addLog({
              action: "Fetch",
              component: "Student Certificate",
              details: `Fetched Student Certificate`
            }).subscribe(data => { });
        } else {
          console.error('Failed to fetch certificates.');
        }
      },
      (error: any) => {
        console.error('Error fetching certificates:', error);
      }
    );
  }
  downloadCertificate (cert: any) {
    let cert_url = cert.certificate_url
    console.log(cert_url);
    this.certificateService.downloadStudentCertificate(cert_url).subscribe((data: any) => {
      if (data.certificate_content) {
        // Decode the base64-encoded certificate content
        const decodedCertificateContent = atob(data.certificate_content);

        // Convert the decoded content to a Blob
        const byteArray = new Uint8Array(decodedCertificateContent.length);
        for (let i = 0; i < decodedCertificateContent.length; i++) {
          byteArray[i] = decodedCertificateContent.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        // Save the Blob as a file
        saveAs(blob, 'certificate.pdf');
        this.snackbar.open("Certificate Downloaded Successfully", 'close', {
          panelClass: data.type,
          duration: 3000
        });
        this.log
          .addLog({
            action: "Download",
            component: "Student Certificate",
            details: `Downloaded Student Certificate`
          }).subscribe(data => { });
      } else {

        this.snackbar.open("Error: Certificate not found", 'close', {
          panelClass: data.type,
          duration: 3000
        });
      }

    }, (error: any) => {
      console.error('Error downloading certificate:', error);
      this.snackbar.open("Error downloading certificate", 'close', {

        duration: 3000
      });
    })
  }

}
